import React, {Component} from "react";

import CircleMemberTableRow from "./circle-member-table-row.js";

import "./circle-member-table.css";

class CircleMemberTable extends Component {
    printCircleMembers() {
        let {circle_members, start_circle_member_edit} = this.props;

        let gotCircleMembers = circle_members && circle_members.length > 0;


        if (!gotCircleMembers) {
            return "";
        }

        else {
            return circle_members.map((circleMember) => {
                    return (
                        <CircleMemberTableRow circle_member={circleMember} start_circle_member_edit={start_circle_member_edit} />
                    )
                });
        }
    }

    render() {
        let {home_user} = this.props;

        let title = "Circle Members";
        if (home_user) {
            let playerName = home_user.first_name;
            title = playerName + "'s Circle";
        }
        
        return (
            <div className='circle_member_table_container'>
                <div className='circle_member_table_title'>{title}</div>
                <div className='home_play_table_wrapper'>
                    <table className='circle_member_table'>
                        <thead>
                            <tr className='circle_member_row'> 
                                <th className='circle_member_th'>Name</th>
                                <th className='circle_member_th'>Email</th>
                                <th className='circle_member_th'>Relationship</th>
                                <th className='circle_member_th'>Last Active</th>
                                <th className='circle_member_th'></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.printCircleMembers()}   
                        </tbody>
                        
                    </table>
                </div>
            </div>
        );
    }


}

export default CircleMemberTable;


// WEBPACK FOOTER //
// ./src/components/containers/home-play/circle-members/circle-member-table.js